import { Box, BoxProps } from '@mui/material';
import useWidth from '../../components/Hooks/useWidth';
import ProductAvailabilityChip from '../../components/Product/ProductAvailabilityChip';
import LangEnum from '../../lang/LangEnum';
import { AvailabilityEnum, CompactAvailability } from './ProductTypes';
import { skuAvailabilityOptions } from './utils/availability.utils';

type ProductAvailabilityRendererProps = {
  availabilities: AvailabilityEnum[];
  boxProps?: BoxProps;
};

const AVAILABILITY_DISPLAY_ORDER = skuAvailabilityOptions.map((option) => option.value);

export const getAvailabilityLangEnum = (
  useFutureStockAsPreOrder: boolean = true,
): Record<AvailabilityEnum | CompactAvailability, LangEnum> => ({
  PRE_ORDER: LangEnum.GLOBAL_PRE_ORDER,
  INFINITE_PRE_ORDER: LangEnum.GLOBAL_PRE_ORDER,
  MATERIAL_PRE_ORDER: useFutureStockAsPreOrder
    ? LangEnum.GLOBAL_PRE_ORDER
    : LangEnum.GLOBAL_MATERIAL_PRE_ORDER,
  READY_FOR_DELIVERY: LangEnum.GLOBAL_READY_FOR_DELIVERY,
  FUTURE_STOCK: useFutureStockAsPreOrder ? LangEnum.GLOBAL_PRE_ORDER : LangEnum.GLOBAL_FUTURE_STOCK,
  EMPTY: LangEnum.GLOBAL_EMPTY,
});

const ProductAvailabilityRenderer = ({
  availabilities,
  boxProps,
}: ProductAvailabilityRendererProps) => {
  const { mobileWidth } = useWidth();
  const visibleAvailabilities = Array.from(new Set(availabilities))
    .filter((av) => av !== AvailabilityEnum.EMPTY)
    .sort((a, b) => AVAILABILITY_DISPLAY_ORDER.indexOf(a) - AVAILABILITY_DISPLAY_ORDER.indexOf(b));

  return (
    <Box
      {...boxProps}
      sx={[
        {
          display: 'flex',
          flexDirection: mobileWidth ? 'column' : 'row',
          flexWrap: 'wrap',
          alignItems: 'flex-start',
          columnGap: '4px',
          rowGap: '4px',
        },
        ...(Array.isArray(boxProps?.sx) ? boxProps.sx : [boxProps?.sx]),
      ]}
    >
      {visibleAvailabilities.map((av) => (
        <ProductAvailabilityChip key={av} availability={av} />
      ))}
    </Box>
  );
};

export default ProductAvailabilityRenderer;
